/*global $*/
/*eslint no-undef: "error"*/

import Swiper from 'swiper'
import {Autoplay, EffectCoverflow, Navigation, Pagination, Thumbs} from 'swiper/modules'

Swiper.use([Navigation, Pagination, EffectCoverflow, Autoplay, Thumbs])

export default class SwiperSlider {
	createVacancy() {
		return new Swiper('#slider--vacancy', {
			navigation: {
				nextEl: '.slider--vacancy-next',
				prevEl: '.slider--vacancy-prev',
				disabledClass: 'button-arrow__button---disabled'
			},
			pagination: {
				el: '.swiper-pagination--vacancy',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 16
				}
			}
		})
	}
	createCompany() {
		return new Swiper('#slider--company', {
			navigation: {
				nextEl: '.slider--company-next',
				prevEl: '.slider--company-prev',
				disabledClass: 'button-arrow__button---disabled'
			},
			pagination: {
				el: '.swiper-pagination--company',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				1440: {
					slidesPerView: 3,
					spaceBetween: 16
				}
			}
		})
	}
	createGallery() {
		return new Swiper('#slider--gallery', {
			navigation: {
				nextEl: '.slider--gallery-next',
				prevEl: '.slider--gallery-prev',
				disabledClass: 'button-arrow__button---disabled'
			},
			pagination: {
				el: '.swiper-pagination--gallery',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				480: {
					slidesPerView: 2,
					spaceBetween: 16
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 16
				}
			}
		})
	}
	createFaq () {
		let swiperBlock =  new Swiper('#slider--faq', {
			navigation: {
				nextEl: '.slider--faq-next',
				prevEl: '.slider--faq-prev',
				disabledClass: ''
			},
			pagination: {
				el: '.swiper-pagination--faq',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: "auto",
					spaceBetween: 0
				}
			}
		})

		$(`.company-slide--tab`).click(function () {
			let block = parseInt($(this).data('block'))

			$(this).closest(`.company-slide--tabs`).find(`.company-slide--tab`).removeClass(`company-slide---active`)
			$(this).addClass(`company-slide---active`)

			if (block === 0) {
				$(`.company-slide--item`).removeClass(`company-faq-items__item---hidden`)
			} else {
				$(`.company-slide--item`).addClass(`company-faq-items__item---hidden`)
				$(`.company-slide--item---${block}`).removeClass(`company-faq-items__item---hidden`)
			}

			swiperBlock.slideTo(block)
		})

		return swiperBlock
	}

	constructor() {
		if (parseInt($('#slider--vacancy').length) > 0) {
			this.createVacancy()
		}

		if (parseInt($('#slider--company').length) > 0) {
			this.createCompany()
		}

		if (parseInt($('#slider--gallery').length) > 0) {
			this.createGallery()
		}

		if (parseInt($('#slider--faq').length) > 0) {
			this.createFaq()
		}
	}
}
